<template>
  <tr :class="'' + container_class">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  props: {
    container_class: {
      type: String,
      default: "",
    },
  },
};
</script>
